const Card = ({ title, children }) => {
  return (
    <div className="flex flex-col bg-sidebar/30 border border-header rounded w-full   shadow-md ">
      <div className=" py-2 px-2 items-center justify-center text-center bg-header/60">
        <span className="font-bold text-xs">{title}</span>
      </div>
      <div className="flex flex-col py-4 px-2 space-y-2  text-xs">
        {children}
      </div>
    </div>
  );
};

export default Card;
